'use client'

import { useState } from 'react'
import { useDwResizer } from '@/components/embeds/EmbedDataWrapper/EmbedDataWrapper'
import { Icon } from '@/components/Icon'
import { Infographic as InfographicTypes } from '@/types/cms'
import { toKebabCase } from '@/utils/string'
import styles from './InfoGraphic.module.scss'

const InfographicSwitch = ({ infographic }: { infographic: InfographicTypes }) => {
  useDwResizer(infographic.model.fields['graf-url'])

  const groupedGraphics = infographic.model.groupedGraphics || []

  const change = (event: React.FormEvent) => {
    setGraphicUrl((event.target as HTMLInputElement).value)
  }

  const slideClick = (event: React.MouseEvent<HTMLElement>, type: string) => {
    event.preventDefault()
    const actualIndex = groupedGraphics.findIndex((x) => x['graf-url'] === graphicUrl)
    const newIndex =
      type === 'backward'
        ? actualIndex === 0
          ? groupedGraphics.length - 1
          : actualIndex - 1
        : actualIndex >= groupedGraphics.length - 1
          ? 0
          : actualIndex + 1

    setGraphicUrl(groupedGraphics[newIndex]['graf-url'])
  }

  const tabClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    const newUrl = (event.target as HTMLElement).getAttribute('href')
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    newUrl && setGraphicUrl(newUrl)
  }

  const [graphicUrl, setGraphicUrl] = useState<string>((groupedGraphics[0] && groupedGraphics[0]['graf-url']) || '')

  if (!infographic.model.groupedGraphics) return <></>

  return (
    <>
      <div
        className={
          styles.switch +
          (infographic.model.fields['layout-type'] === 'use-tabs' ? ' ' + styles.switchtab : '') +
          (infographic.model.fields['layout-type'] === 'click-through' ? ' ' + styles.switchclick : '')
        }
      >
        {infographic.model.fields['layout-type'] === 'click-through' && (
          <button className={styles.backward} onClick={(event) => slideClick(event, 'backward')}>
            <Icon name="chevronLeft" />
          </button>
        )}
        <select value={graphicUrl} onChange={change}>
          {groupedGraphics.map((graphic, index) => {
            const contextId = graphic.id ?? toKebabCase(graphic['tab-title']) + index

            return (
              <option key={contextId} value={graphic['graf-url']}>
                {graphic['tab-title']}
              </option>
            )
          })}
        </select>
        {infographic.model.fields['layout-type'] === 'click-through' && (
          <button className={styles.forward} onClick={(event) => slideClick(event, 'forward')}>
            <Icon name="chevronRight" />
          </button>
        )}
        {infographic.model.fields['layout-type'] === 'use-tabs' && (
          <ul>
            {groupedGraphics.map((graphic, index) => {
              const contextId = graphic.id ?? toKebabCase(graphic['tab-title']) + index
              return (
                <li key={contextId} className={graphic['graf-url'] === graphicUrl ? styles['selected-tab'] : undefined}>
                  <a onClick={tabClick} href={graphic['graf-url']}>
                    {graphic['tab-title']}
                  </a>
                </li>
              )
            })}
          </ul>
        )}
      </div>
      <iframe src={graphicUrl} title="Infografik" loading="lazy" />
    </>
  )
}

export default InfographicSwitch
